import React from 'react';

import useBudgetQuery from './useBudgetQuery';

import DailyPublishedBudgetChart from './DailyPublishedBudgetChart';
import WeeklyAllocatedBudgetChart from './WeeklyAllocatedBudgetChart';
import BudgetOverview from './BudgetOverview';
import '../styles/reports.scss';
import { BudgetDropdown } from './BudgetDropdown/BudgetDropdown';
import Forecast from './Forecast/Forecast';
import ReportPageLoader from './ReportPageLoader/ReportPageLoader';

const ReportsIndex = ( ) => {
    const {tenantBudgets, 
        setBudget, 
        currentBudget, 
        weeklyAllocations, 
        publishedBudget, 
        allocatedBudget, 
        dailyPublishedBudget, 
        weeklyForecast, 
        isLoading,
        forecastSummary,
        monthlyForecast} = useBudgetQuery();

    const handleChange = (e) => {
        setBudget(e.target.value);
    };

    const getLoadedBudget = () => {
        return isLoading 
        ? <ReportPageLoader />
        : (<>
            <div className='content-container'>
            <div className='progress-contaier'>
                {(currentBudget && allocatedBudget && publishedBudget) &&
                    <BudgetOverview budget={currentBudget} allocatedBudget={allocatedBudget}
                                    publishedBudget={publishedBudget}/>
                }
            </div> 
            </div>
            <div className='content-container'>
                <div className='progress-contaier mt-20'>
                    <WeeklyAllocatedBudgetChart weeklyAllocations={weeklyAllocations} />
                </div>
            </div>
            <div className='daily-published-container'>
                <DailyPublishedBudgetChart dailyPublishedBudget={dailyPublishedBudget}/>
            </div>
            <div className='daily-published-container'>
                <Forecast forecastSummary={forecastSummary} weeklyForecast={weeklyForecast} monthlyForecast={monthlyForecast}/>
            </div>
        </>);
    };


    return (
        <div id="budget-container">
            <div className="title-container">
                <div className='budget-info'>
                    <h1 className='font-secondary font-weight-500 font-size-24 text-color-dark-grey'>Budget</h1>
                    <p className='font-primary'>Your budget&apos;s progress</p>
                </div>
                <BudgetDropdown budgets={tenantBudgets} budget={currentBudget} onBudgetChange={handleChange} />
            </div>
            {currentBudget ? getLoadedBudget() : <p>Please choose a budget to view the report</p>}
        </div>
    );
};

  export default ReportsIndex;
